import { render, staticRenderFns } from "./list-product.vue?vue&type=template&id=af3b03b8&scoped=true&"
import script from "./list-product.vue?vue&type=script&lang=js&"
export * from "./list-product.vue?vue&type=script&lang=js&"
import style0 from "./list-product.vue?vue&type=style&index=0&id=af3b03b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b03b8",
  null
  
)

export default component.exports